module.exports = __webpack_public_path__ + "img/no-root.85f08be9.png";